/* eslint-disable react/no-danger */
import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';
import { Splide, SplideSlide } from '@splidejs/react-splide';

import carouselItems from './carouselItems.json';

const StyledSplide = styled(Splide)`
  .splide__pagination {
    display: flex;
    justify-content: left;
    padding-top: 24px;
    padding-left: 28px;
  }

  .splide__pagination__page {
    border-radius: 12px;
    width: 8px;
    height: 8px;
    margin-right: 20px;
    background-color: ${nuDSColor('black.defaultT20')};
    
    &.is-active {
      width: 16px;
      background-color: ${nuDSColor('primary')};
    }
  }
`;

const StyledImage = styled(Image)`
  max-width: 306px;
  height: 240px;
  border-radius: 12px 12px 0 0;
  object-fit: cover;
`;

function MobileSplideCarousel() {
  return (

    <Box
      background="white"
      width="100%"
      height="100%"
      display={{ xs: 'block', md: 'none' }}
    >
      <StyledSplide
        aria-label="features-account-carousel"
        options={{
          arrows: false,
          perPage: 1,
          mediaQuery: 'min',
          breakpoints: {
            600: { perPage: 2 },
          },
          padding: { right: '60px' },
        }}
      >
        {carouselItems.map(item => (
          <SplideSlide key={item.id}>
            <Box
              display="flex"
              marginLeft="24px"
              height="100%"
            >

              <Box
                display="flex"
                flexDirection="column"
              >
                {/* IMAGE */}

                <StyledImage
                  alt={item.alt}
                  src={item.image}
                  width={{ xs: '100%' }}
                  height={{ xs: 'auto' }}
                  loading="lazy"
                  webP
                />

                {/* CONTENT */}

                <Box
                  backgroundColor="#F8F8FA"
                  borderRadius="0px 0px 12px 12px"
                  paddingVertical={{ xs: '30px' }}
                  paddingHorizontal={{ xs: '32px' }}
                  minHeight="300px"
                  display="flex"
                  flexDirection="column"
                >
                  <Typography
                    variant="heading3"
                    strong
                    marginBottom="20px"
                    textAlign="left"
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    variant="paragraph1"
                  >
                    {item.description}
                  </Typography>

                </Box>

              </Box>

            </Box>
          </SplideSlide>
        ))}

      </StyledSplide>
    </Box>
  );
}

export default MobileSplideCarousel;
